import Wizard from './Wizard';
import Switch from './Switch';
import { BackButton, CloseButton } from './NavigationButton';
import PageWithTitle from './PageWithTitle';
import WizardStep from './WizardStep';
import SwitchWithPagination from './SwitchWithPagination';

export default Wizard;
export { Wizard, Switch, BackButton, CloseButton, PageWithTitle, WizardStep, SwitchWithPagination };
